import { createSlice } from "@reduxjs/toolkit";
import { ReportNewsState } from "./types";

export const initialState: ReportNewsState = {
  loading: false,
  error: false,
  success: false,
  errorMessage: "",
  successData: null,
};

export const reportNewsSlice: any = createSlice({
  name: "reportNews",
  initialState,
  reducers: {
    createNews: (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
      state.errorMessage = "";
    },
    createNewsSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.successData = action.payload;
      state.error = false;
    },
    createNewsFailed: (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
      state.errorMessage = action.payload || "Failed to create news";
    },
    resetReportNews: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.errorMessage = "";
      state.successData = null;
    },
  },
});

export const {
  createNews,
  createNewsSuccess,
  createNewsFailed,
  resetReportNews,
} = reportNewsSlice.actions;

export default reportNewsSlice.reducer;
